import { WordingMultiAstrologyMeditationLove } from '@/types';

export const MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_LV: WordingMultiAstrologyMeditationLove = {
  components_header_media_content: 'Astroloģija',
  components_header_media_multi_content_2: 'Meditācija',
  components_header_media_multi_content_3: 'Mīlestība',
  components_header_text1: 'Ceļveži',
  components_header_text2: 'Blogs',
  hero_text: 'Atrodi skaidrību, līdzsvaru un saikni.',
  hero_button_text: 'Sāciet savu ceļojumu',
  components_ressources_subheader_text: 'Padomi un iedvesma',
  components_ressources_span_text: 'Tas apvieno personīgās astroloģijas atziņas, nomierinošas meditācijas prakses un pārdomātu mīlestības vadību, lai atbalstītu sevis izzināšanu, emocionālo līdzsvaru un dziļāku saikni.',
  components_ressources_card_1_title: 'Meditācijas padomi',
  components_ressources_card_1_text: 'Īsa pamācība labākai nomierināšanai, elpošanai un koncentrēšanās spējas iegūšanai.',
  components_ressources_card_2_title: 'Mīlestības vadība',
  components_ressources_card_2_text: 'Vienkārši padomi, kā veidot ciešāku saikni un emocionālu līdzsvaru.',
  components_ressources_link: 'Uzziniet vairāk',
  components_notes_and_google_title_1: 'Atrodi skaidrību',
  components_notes_and_google_title_2: 'Iekšējais miers',
  components_notes_and_google_title_3: 'Sirds savienojums',
  media_content_section_multi_1_subheader_text: 'Mūsu podkāsts',
  media_content_section_multi_2_subheader_text: 'Mūsu meditācijas',
  media_content_section_multi_3_subheader_text: 'Īsta saruna par kosmisko romantiku',
  page_media_content_menu_antistress: 'Antistresa',
  page_media_content_menu_mindfulness: 'Apzinātība',
  page_media_content_menu_energyboost: 'Enerģijas pieplūdums',
  page_media_content_menu_mantra: 'Mantra',
  page_media_content_menu_foundations: 'Pamati',
  page_media_content_menu_spirituality: 'Garīgums',
  page_media_content_menu_tarot: 'Taro',
  page_media_content_menu_psychology: 'Psiholoģija',
  page_media_content_menu_trends: 'Tendences',
  page_media_content_menu_compatibility: 'Saderība',
  page_media_content_menu_love: 'Mīlestība',
  text2_section_title: 'BLOGS',
  text2_section_subheader_text: 'Raksti un atziņas',
  text2_section_button_more: 'Ielādēt vairāk',
  components_text1_section_title: 'ROKASGRĀMATA',
  components_text1_subheader_text: 'Kosmiskās zināšanas ikdienas saskaņošanai',
  components_text1_span_text: 'Saskaņojieties ar Visuma ritmiem: izpētiet rūpīgi atlasītu padziļinātu astroloģisko un meditatīvo ceļvežu kolekciju, kas paredzēta, lai atmodinātu iekšējo skaidrību, padziļinātu pašapziņu un atbalstītu jūsu dvēseliskās, debesu izaugsmes ceļojumu.',
  components_text1_card_1_title: 'Atvērts klusumam',
  components_text1_card_1_text: 'Sāciet savu ceļojumu ar pamata meditācijas un astroloģijas ceļvežiem — ideāli piemēroti meklētājiem, kurus piesaista iekšējais miers, kosmiskie modeļi un personīgā atziņa.',
  components_text1_card_3_title: 'Prāta un ķermeņa saikne',
  components_text1_card_3_text: 'Atklājiet savas iekšējās pasaules dziļākos slāņus. Šie ceļveži sniedzas tālāk par virsmu, lai atklātu nozīmi, emocijas un apzinātības modeļus, kas veido jūsu pieredzi.',
  components_text1_card_2_title: 'Pārdomāt un integrēt',
  components_text1_card_2_text: 'No emocionāliem blokiem līdz planētu cikliem — šie ceļveži piedāvā rīkus pārdomām, dziedināšanai un transformācijai, izmantojot apzinātus rituālus un astroloģisko gudrību.',
  components_text1_link: 'Skatīt visus ceļvežus',
  components_footer_text: 'Atrodi skaidrību, līdzsvaro savu prātu un satiecies ar jēgu – tava vieta astroloģijai, meditācijai un mīlestībai.',
};